import { masterDataService, defaultParams } from 'services'

export const getRegionListApi = () => {
  return masterDataService({
    method: 'get',
    url: '/address/autocomplete',
  })
}

export const getAddressListApi = stakeholderId => {
  return masterDataService({
    method: 'post',
    url: '/address/query?address',
    data: {
      where: [
        {
          ...defaultParams,
          stakeholderId,
          filter: 'my-address',
        },
      ],
      order: {
        runningId: 'DESC',
      },
      limit: 1000,
    },
  })
}

export const getAddressByIdApi = id => {
  return masterDataService({
    method: 'post',
    url: '/address/query?address',
    data: {
      where: [{ ...defaultParams, id, filter: 'my-address' }],
      limit: 1,
    },
  })
}

export const createAddressApi = data => {
  return masterDataService({
    method: 'post',
    url: '/address',
    data,
  })
}

export const updateAddressApi = async (id, data) => {
  return masterDataService({
    method: 'patch',
    url: `/address/${id}`,
    data,
  })
}

export const getContactPersonListApi = stakeholderId => {
  return masterDataService({
    method: 'post',
    url: '/contactPerson/query?contactPerson',
    data: {
      where: [
        {
          ...defaultParams,
          stakeholderId,
          filter: 'my-contact-person',
        },
      ],
      order: {
        runningId: 'DESC',
      },
      limit: 1000,
    },
  })
}

export const createContactPersonApi = data => {
  return masterDataService({
    method: 'post',
    url: '/contactPerson',
    data,
  })
}

export const updateContactPersonApi = async (id, data) => {
  return masterDataService({
    method: 'patch',
    url: `/contactPerson/${id}`,
    data,
  })
}

export const getBillingAddressListApi = stakeholderId => {
  return masterDataService({
    method: 'post',
    url: '/billingAddress/query',
    data: {
      where: [
        {
          ...defaultParams,
          stakeholderId,
          filter: 'my-billing-address',
        },
      ],
      order: {
        runningId: 'DESC',
      },
      limit: 1000,
    },
  })
}

export const getBillingAddressByIdApi = id => {
  return masterDataService({
    method: 'post',
    url: '/billingAddress/query',
    data: {
      where: [{ ...defaultParams, id, filter: 'my-billing-address' }],
      limit: 1,
    },
  })
}

export const createBillingAddressApi = data => {
  return masterDataService({
    method: 'post',
    url: '/billingAddress',
    data,
  })
}

export const updateBillingAddressApi = async (id, data) => {
  return masterDataService({
    method: 'patch',
    url: `/billingAddress/${id}`,
    data,
  })
}
